export class EmptyQueueError extends Error {
  public message = '';

  public name = 'EmptyQueueError';

  public stack = '';
}
